exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#OffersBanner {\n  margin: -1.9rem !important;\n  margin-bottom: 1rem !important; }\n  #OffersBanner .element-box {\n    background-color: inherit !important; }\n", ""]);

// exports
